import React from 'react'
import Button from 'shared/components/Button'
import styled from 'styled-components'
import Box from 'shared/components/Box'

export type DialogActionsProps = {
  onContinue: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void
  onCancel: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void
  onExtra: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void
  isProcessing: boolean
  continueIsDisabled?: boolean
  hasExtra?: boolean
  hasCancel?: boolean
  hasContinue?: boolean
  cancelLabel?: string
  extraLabel?: string
  isNewDesign?: boolean
  continueLabel?: string
  role_level?: number
  context?: 'action' | 'informational'
}

function DefaultDialogActions(props: DialogActionsProps) {
  const {
    onContinue,
    onCancel,
    onExtra,
    isProcessing,
    continueLabel,
    hasCancel,
    cancelLabel,
    hasExtra,
    extraLabel,
    isNewDesign = false,
    hasContinue,
    continueIsDisabled,
    role_level,
  } = props

  return (
    <>
      {!isProcessing && isNewDesign && (
        <>
          {hasCancel && hasContinue && (
            <NewDesignButtonContainer>
              {hasExtra && (
                <NewDesignActionButton variant="outline-primary" mx="10px" onClick={onExtra} children={extraLabel} />
              )}
              {continueLabel && (
                <NewDesignActionButton
                  disabled={continueIsDisabled}
                  isLoading={isProcessing}
                  variant="outline-primary"
                  mx="10px"
                  onClick={() => {
                    if (!isProcessing) onContinue()
                  }}
                  children={continueLabel}
                />
              )}
              {cancelLabel && (
                <CancelActionButton
                  onClick={onCancel}
                  mt="20px"
                  height="30px"
                  children={cancelLabel}
                  $isNewDesign={isNewDesign}
                />
              )}
            </NewDesignButtonContainer>
          )}
        </>
      )}

      {!isNewDesign && (
        <>
          {hasCancel && !hasContinue && <CancelOnlyButton onClick={onCancel} children={cancelLabel} />}
          {!hasCancel && hasContinue && (
            <>
              {hasExtra && (
                <ActionButton variant="primary" width="157px" mr="20px" onClick={onExtra} children={extraLabel} />
              )}
              <ActionButton
                disabled={continueIsDisabled}
                isLoading={isProcessing}
                variant="primary"
                width="157px"
                onClick={() => {
                  if (!isProcessing) onContinue()
                }}
                children={continueLabel}
              />
            </>
          )}
          {hasCancel && hasContinue && (
            <>
              {cancelLabel && (
                <ActionButton variant="outline-primary" onClick={onCancel} children={cancelLabel} mr="20px" />
              )}
              {hasExtra && <ActionButton variant="primary" mr="20px" onClick={onExtra} children={extraLabel} />}
              {continueLabel && (
                <ActionButton
                  disabled={continueIsDisabled}
                  isLoading={isProcessing}
                  variant="primary"
                  onClick={() => {
                    if (!isProcessing) onContinue()
                  }}
                  children={continueLabel}
                />
              )}
            </>
          )}
        </>
      )}
    </>
  )
}

const ActionButton = styled(Button)<{ $isNewDesign?: boolean; context?: 'action' | 'informational' }>`
  padding: 0 32px;
  padding: 0 24px;
  min-width: 140px;

  ${({ $isNewDesign }) => ($isNewDesign ? `height: 30px;` : `height: 56px;`)}
`

const CancelActionButton = styled(Button)<{ $isNewDesign?: boolean }>`
  padding: 0 32px;
  padding: 0 24px;
  min-width: 140px;
  color: ${({ theme }) => theme.colors.main};

  ${({ $isNewDesign }) => ($isNewDesign ? `height: 30px;` : `height: 56px;`)}
`

export const CancelOnlyButton = styled(Button)`
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.main};
  height: fit-content;
`

export const NewDesignButtonContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`

const NewDesignActionButton = styled(Button)`
  padding: 0 32px;
  padding: 0 24px;
  min-width: 140px;
  height: 56px;
`

DefaultDialogActions.defaultProps = {
  cancelLabel: 'Cancel',
  continueLabel: 'OK',
  hasCancel: true,
  hasContinue: true,
  hasExtra: false,
}

export default DefaultDialogActions
